import CryptoJS from 'crypto-js';
import { hash } from './config';

/**
 * Encrypts the payload using AES-256-CBC encryption.
 * @param {Object} payload - The payload object to encrypt.
 * @returns {string} - The encrypted payload as a base64 string.
 */
export const encryptPayload = (payload) => {
  try {
    // Convert payload object to JSON string
    const payloadString = JSON.stringify(payload);
    // Encrypt the data
    const encrypted = CryptoJS.AES.encrypt(payloadString, hash);

    // Return the result as a base64 string
    return encrypted.toString();
  } catch (error) {
    console.error("Encryption failed:", error);
    throw new Error("Failed to encrypt payload");
  }
};

/**
 * Decrypts an encrypted payload.
 * @param {string} encryptedPayload - The encrypted payload as a base64 string.
 * @returns {Object} - The decrypted payload as an object.
 */
export const decryptPayload = (encryptedPayload) => {
  try {
    
    // Decrypt the data
    const decrypted = CryptoJS.AES.decrypt(encryptedPayload, hash);

    // Convert the decrypted data back to a JSON string
    const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
    

    // Parse the decrypted JSON string back to an object
    return JSON.parse(decryptedString);
  } catch (error) {

    throw new Error("Failed to decrypt payload");
  }
};
